import { render, staticRenderFns } from "./MyAddress.vue?vue&type=template&id=a2af6a66&"
import script from "./MyAddress.vue?vue&type=script&lang=js&"
export * from "./MyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports